const Trash = () => {
  return (
    <svg className="fill-current w-6 h-6" width="18" height="24" viewBox="0 0 18 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="Group">
        <path
          id="Vector"
          d="M15.3377 3.30001H12.4502V2.66251C12.4502 1.53751 11.5502 0.637512 10.4252 0.637512H7.5377C6.4127 0.637512 5.5127 1.53751 5.5127 2.66251V3.30001H2.6252C1.5377 3.30001 0.637695 4.20001 0.637695 5.28751V6.41251C0.637695 7.23751 1.1252 7.91251 1.8377 8.21251L2.4377 21.1875C2.5127 22.425 3.4877 23.3625 4.7252 23.3625H13.1627C14.4002 23.3625 15.4127 22.3875 15.4502 21.1875L16.1252 8.17501C16.8377 7.87501 17.3252 7.16251 17.3252 6.37501V5.25001C17.3252 4.20001 16.4252 3.30001 15.3377 3.30001ZM7.23769 2.66251C7.23769 2.47501 7.3877 2.32501 7.5752 2.32501H10.4627C10.6502 2.32501 10.8002 2.47501 10.8002 2.66251V3.30001H7.2752V2.66251H7.23769ZM2.3627 5.28751C2.3627 5.13751 2.4752 4.98751 2.6627 4.98751H15.3377C15.4877 4.98751 15.6377 5.10001 15.6377 5.28751V6.41251C15.6377 6.56251 15.5252 6.71251 15.3377 6.71251H2.6627C2.5127 6.71251 2.3627 6.60001 2.3627 6.41251V5.28751ZM13.2002 21.675H4.8002C4.4627 21.675 4.2002 21.4125 4.2002 21.1125L3.6002 8.40001H14.4377L13.8377 21.1125C13.8002 21.4125 13.5377 21.675 13.2002 21.675Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M9.0002 11.6625C8.5502 11.6625 8.1377 12.0375 8.1377 12.525V18.3375C8.1377 18.7875 8.5127 19.2 9.0002 19.2C9.4502 19.2 9.86269 18.825 9.86269 18.3375V12.4875C9.86269 12.0375 9.4502 11.6625 9.0002 11.6625Z"
          fill="currentColor"
        />
        <path
          id="Vector_3"
          d="M12.4875 12.375C12.0375 12.3375 11.625 12.7125 11.5875 13.1625L11.3625 17.475C11.325 17.925 11.7 18.3375 12.15 18.375H12.1875C12.6375 18.375 13.0125 18.0375 13.0125 17.5875L13.2375 13.275C13.3125 12.7875 12.9375 12.4125 12.4875 12.375Z"
          fill="currentColor"
        />
        <path
          id="Vector_4"
          d="M5.47515 12.375C5.02515 12.4125 4.65015 12.7875 4.68765 13.275L4.95015 17.625C4.98765 18.075 5.36265 18.4125 5.77515 18.4125H5.81265C6.26265 18.375 6.63765 18 6.60015 17.5125L6.37515 13.1625C6.33765 12.7125 5.92515 12.3375 5.47515 12.375Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default Trash;
